export default __webpack_public_path__ + "static/hover_materials-451fc684597a8b27676139dee5cb232a.mp4";